import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { DataSharingService } from '../../../../shared/services/data-sharing/data-sharing.service';

@Component({
  selector: 'app-bottom-nav',
  templateUrl: './bottom-nav.component.html',
  styleUrl: './bottom-nav.component.css',
})
export class BottomNavComponent {
  selected: string = 'Home';
  navItems = [
    { icon: 'pi pi-home', label: 'Home', route: '/trading/market' },
    { icon: 'pi pi-chart-line', label: 'Market', route: '/trading/pairs' },
    { icon: 'pi pi-chart-bar', label: 'Trade', route: '/trading/chart' },
    // { icon: 'pi pi-book', label: 'Book', route: '/book' },
    { icon: 'pi pi-wallet', label: 'Portfolio', route: '/user/account' },
  ];

  constructor(
    private router: Router,
    private dataSharingService: DataSharingService,
  ) {}

  ngOnInit() {
    this.dataSharingService.mobileBottomNavigation$.subscribe((_res: any) => {
      this.selected = _res;
    });
  }

  navigate(route: any) {
    this.selected = route.label;
    this.dataSharingService.onMobileNavigationChange(this.selected);
    this.router.navigate([route.route]);
  }
}
